import { DataType } from "../../../../form/typings";
import { styleControlOptions } from "../../../../form/component-schema";
import { SheetDisplayMode } from "../../../../form/src/common/component-schema/complex-control-options";
import i18n from "../../../i18n";
export default {
    $id: "sheet",
    type: DataType.Object,
    $ref: styleControlOptions.$id,
    properties: {
        width: {
            type: DataType.Number,
            title: i18n.t('dataitem.ColumnWidth').toString(),
            default: 150,
        },
        widgetType: {
            type: DataType.String,
            title: i18n.t('dataitem.ControlType').toString(),
            default: "子表",
        },
        dataItemType: {
            type: DataType.String,
            title: i18n.t('dataitem.DataItemType').toString(),
        },
        //默认行数
        rows: {
            type: DataType.Number,
            title: i18n.t('dataitem.DefaultRows').toString(),
            default: 2,
        },
        editable: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.Editable').toString(),
            default: true,
        },
        isEmptyRow: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.EmptyLine').toString(),
            default: false,
        },
        importable: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.Importable').toString(),
            default: true,
        },
        exportable: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.Emportable').toString(),
            default: true,
        },
        importFormRelevanceForm: {
            type: DataType.String,
            title: i18n.t('dataitem.ImportFromRelevanceForm').toString(),
        },
        showTotal: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.DisplaySummaryRows').toString(),
        },
        showAllEdit: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.BatchEditable').toString(),
        },
        sheetFiters: {
            type: DataType.Array,
            title: i18n.t('dataitem.SheetQueryCondition').toString(),
        },
        displayFormula: {
            type: DataType.String,
            title: i18n.t('dataitem.DisplayConditions').toString(),
        },
        onAddRow: {
            type: DataType.String,
            title: i18n.t('dataitem.AddRowEvent').toString(),
        },
        onDeleteRow: {
            type: DataType.String,
            title: i18n.t('dataitem.DeleteRowEvent').toString(),
        },
        mobileDisplayMode: {
            type: DataType.String,
            title: i18n.t('dataitem.MobileStyle').toString(),
            default: SheetDisplayMode.Page,
        },
        labelVisible: {
            type: DataType.Boolean,
            title: i18n.t('dataitem.LabelVisible').toString(),
            default: true,
        },
    },
};
